import { combineAfterDispatches } from "lib/store";
import { logger } from "./logger";

export const afterDispatches = combineAfterDispatches([logger]);
